// extracted by mini-css-extract-plugin
export default {"messageItem":"messageItem-a6nZiQ","error":"error-eJrzA3","success":"success-RldgDI","content":"content-CqT_pE"};